import { motion } from "framer-motion";
import { WHY } from "@/data/site";
import { Reveal } from "@/lib/motion";

const PHOTOS = [
  { src: "/images/interior-front.jpg", alt: "Detailed leather interior", cls: "row-span-2" },
  { src: "/images/interior-rear.jpg", alt: "Cleaned rear seating" },
  { src: "/images/interior-dash.jpg", alt: "Detailed dashboard and trim" },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-choose-us" className="relative z-10 overflow-hidden bg-[#0B0D11] py-24 sm:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(23,147,255,0.14),transparent_40%)]" />
      <div className="container-x relative grid gap-14 lg:grid-cols-2 lg:items-center">
        <div className="grid grid-cols-2 gap-4">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={i * 0.08} className={`${p.cls || ""}`}>
              <div className="group relative h-full overflow-hidden rounded-2xl border border-[var(--line)] frame-clip">
                <img src={p.src} alt={p.alt}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#08090B]/60 via-transparent to-transparent" />
                <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(circle_at_50%_50%,rgba(56,182,255,0.22),transparent_60%)]" />
              </div>
            </Reveal>
          ))}
        </div>

        <div>
          <Reveal>
            <span className="eyebrow mb-4"><span className="h-px w-8 bg-[var(--blue-bright)]" /> Why Choose Us</span>
            <h2 className="font-display text-4xl font-800 leading-tight tracking-tight text-white sm:text-5xl">
              Real results. <span className="text-[var(--blue-bright)]">Fair prices.</span>
            </h2>
            <p className="mt-4 max-w-md text-base text-[var(--muted)]">
              See the difference in the detail — spotless leather, gleaming trim and a finish that lasts.
            </p>
          </Reveal>

          <div className="mt-10 space-y-2">
            {WHY.map((w, i) => (
              <motion.div key={w.n}
                initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                className="flex items-start gap-5 border-t border-[var(--line)] py-5">
                <span className="font-display text-2xl font-800 text-[var(--blue)]/70">{w.n}</span>
                <div>
                  <h3 className="font-display text-lg font-700 text-white">{w.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-[var(--muted)]">{w.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
